import { QuestionTextField, QuestionDropDownField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionSignerBlock, QuestionUsTinBlock, QuestionW9TaxClassificationBlock } from 'components/Questionnaires/blocks';
import { requiredValidator } from 'components/Questionnaires/validators';

const w9 = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.W9.name',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'name',
          label: 'questionnaire.W9.name.name.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.W9.name.name.info'
          },
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.W9.name.name.errorMessage' }
            ]
          }
        },
        {
          id: 'businessName',
          label: 'questionnaire.W9.name.businessName.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.disregardedEntity.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => !preQualAnswers || Object.keys(preQualAnswers).length === 0 || preQualAnswers?.usIncome?.dbaDre === 'Yes',
        },
      ]
    },
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'taxClassification',
      title: 'questionnaire.W9.taxClassification',
      component: QuestionW9TaxClassificationBlock,
      visible: (qAnswers, preQualAnswers) => !preQualAnswers || Object.keys(preQualAnswers).length === 0 || (preQualAnswers?.individual?.answer === 'No' && !preQualAnswers?.usIncome?.soleOwner === 'Yes'),
    },
    {
      id: 'exemptions',
      title: 'questionnaire.W9.exemptions',
      visible: (qAnswers, preQualAnswers) => !preQualAnswers || Object.keys(preQualAnswers).length === 0 || (preQualAnswers?.individual?.answer === 'No' && !preQualAnswers?.usIncome?.soleOwner === 'Yes'),
      questions: [
        {
          id: 'exemptPayeeCode',
          label: 'questionnaire.W9.exemptions.exemptPayeeCode.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.W9.exemptions.exemptPayeeCode.items',
          },
          default: '',
          info: {
            instructions: 'questionnaire.W9.exemptions.exemptPayeeCode.info'
          },
          visible: true,
        },
        {
          id: 'fatcaReportingCode',
          label: 'questionnaire.W9.exemptions.fatcaReportingCode.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.W9.exemptions.fatcaReportingCode.items',
          },
          default: '',
          info: {
            instructions: 'questionnaire.W9.exemptions.fatcaReportingCode.info'
          },
          visible: true,
        },
      ]
    },
    {
      id: 'usTin',
      title: 'questionnaire.usTin',
      component: QuestionUsTinBlock,
      visible: true
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        individualOnly: true,
        showBackupWhd: true
      },
      visible: true
    },
  ]
};

export default w9;
